import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { Home, MessageSquare, ShoppingBag, ClipboardList, Award } from 'lucide-react';

const BottomNav = () => {
  const location = useLocation();
  const { cartCount } = useCart();
  
  const isActive = (path) => location.pathname === path;
  
  const navItems = [
    { path: '/', icon: Home, label: 'Início' },
    { path: '/assistant', icon: MessageSquare, label: 'Assistente' },
    { path: '/catalog', icon: ShoppingBag, label: 'Produtos', badge: cartCount },
    { path: '/orders', icon: ClipboardList, label: 'Pedidos' },
    { path: '/loyalty', icon: Award, label: 'Fidelidade' },
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 safe-bottom bg-white border-t border-zinc-200 flex items-center justify-around z-50 px-2 shadow-lg">
      {navItems.map(({ path, icon: Icon, label, badge }) => (
        <Link
          key={path}
          to={path}
          className={`flex flex-col items-center justify-center py-2 px-3 rounded-xl transition-colors active-scale relative ${
            isActive(path) 
              ? 'text-sonangol-red' 
              : 'text-zinc-500 hover:text-zinc-700'
          }`}
          data-testid={`nav-${label.toLowerCase().replace(' ', '-')}`}
        >
          <Icon className="w-5 h-5" strokeWidth={isActive(path) ? 2.5 : 2} />
          <span className={`text-[10px] mt-1 font-manrope ${isActive(path) ? 'font-semibold' : ''}`}>
            {label}
          </span>
          {badge > 0 && (
            <span className="absolute -top-1 right-0 w-4 h-4 bg-sonangol-red text-white text-[10px] font-bold rounded-full flex items-center justify-center">
              {badge > 9 ? '9+' : badge}
            </span>
          )}
        </Link>
      ))}
    </nav>
  );
};

export default BottomNav;
